import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { APTContext } from "../services/aptContext/apt-context";

export const DownloadsGuard: CanActivateFn = () => {
  const aptContext = inject(APTContext);
  const router = inject(Router);
  if (aptContext.isOfflineWebMode) {
    void router.navigateByUrl("/ws");
    return false;
  }
  return true;
};
